/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ApplicationInsightsPolicyModule
 */

import { IApplicationSamplingConfig } from 'generated-types';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

export class ApplicationSamplingConfigConfigItem extends MessageItem<IApplicationSamplingConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: 'ApplicationSamplingConfig',
            ...args,
        };

        super(extendedArgs);
    }
}
